import { analyticsManager } from './analytics-utils.js';

window.AvarnsecurityForms = window.AvarnsecurityForms || {};

class SendMessageFormHandler {
    constructor(formId) {
        this.form = document.getElementById(formId);
        this.feedbackDiv = this.form.querySelector('.modal-form__feedback') || this.form.querySelector('.feedback');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.formType = this.form.dataset.formType;
        this.formLocation = this.form.dataset.formLocation || null;
        this.isProcessing = false;

        this.setupEventListeners();

        // Store instance in the global namespace for access from reCAPTCHA
        window.AvarnsecurityForms[formId] = this;
    }

    setupEventListeners() {
        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            await this.submitForm();
        });

        this.form.querySelectorAll('input, textarea').forEach(input => {
            input.addEventListener('input', () => {
                const errorDiv = input.closest('.form-group')?.querySelector('.validation-failed');
                if (errorDiv) {
                    errorDiv.style.display = 'none';
                }
            });
        });
    }

    // Public method that can be called from reCAPTCHA callback
    async submitForm() {
        if (this.isProcessing) return;

        // Check form validity
        if(!this.form.checkValidity()) {
            this.form.reportValidity();
            return;
        }

        this.isProcessing = true;
        this.clearValidationMessages();
        this.setLoadingState(true);

        try {
            const formData = new FormData(this.form);
            const response = await fetch(this.form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'RequestVerificationToken': document.querySelector('input[name="__RequestVerificationToken"]').value
                }
            });

            const result = await response.json();

            if (!response.ok) {
                this.handleValidationErrors(result);
            } else {
                this.handleSuccess(result);
            }
        } catch (error) {
            this.showFeedback(
                this.form.dataset.errorMessage || 'An error occurred while processing your request. Please try again later.',
                false
            );
        } finally {
            this.setLoadingState(false);
            this.isProcessing = false;
        }
    }

    clearValidationMessages() {
        if(this.feedbackDiv == null) return;

        this.form.querySelectorAll('.validation-failed').forEach(div => {
            div.style.display = 'none';
        });
        this.feedbackDiv.style.display = 'none';
    }

    handleValidationErrors(result) {
        if (result.Errors && result.Errors.length > 0) {
            result.Errors.forEach(error => {
                const fieldName = error.MemberNames?.[0]?.toLowerCase() || '';
                const input = this.form.querySelector(`[name="${fieldName}"i]`);
                if (input) {
                    const errorDiv = input.closest('.form-group')?.querySelector('.validation-failed');
                    if (errorDiv) {
                        errorDiv.textContent = error.ErrorMessage;
                        errorDiv.style.display = 'block';
                    }
                }
            });
        }

        if (result.message) {
            this.showFeedback(result.message, false);
        }
    }

    handleSuccess(result) {
        if (result.Success) {
            this.form.reset();
            this.showFeedback(result.Message, true);

            // Execute form-specific callback if it exists
            if (this.formType) {
                analyticsManager.trackFormSubmission(this.formType, result.FormData, this.formLocation);
            }

            if (result.redirectTo) {
                setTimeout(() => {
                    window.location.href = result.RedirectTo;
                }, 2000);
            }
        } else {
            this.showFeedback(result.Message, false);
        }
    }

    showFeedback(message, isSuccess) {
        if(this.feedbackDiv == null) return;
        const content = this.feedbackDiv.querySelector('.content');
        if (content) {
            content.textContent = message;
        }

        const icon = this.feedbackDiv.querySelector('.icon');
        if (icon) {
            if (isSuccess) {
                icon.classList.remove('text-red-800');
                icon.classList.remove("icon-close");
                icon.classList.add("icon-checkmark");
            } else {
                icon.classList.add('text-red-800');
                icon.classList.add("icon-close");
                icon.classList.remove("icon-checkmark");
            }
        }

        this.feedbackDiv.classList.toggle('bg-foreground-light', isSuccess);
        this.feedbackDiv.classList.toggle('bg-red-800', !isSuccess);
        this.feedbackDiv.style.display = 'flex';
    }

    setLoadingState(isLoading) {
        if (!this.submitButton) return;

        this.submitButton.disabled = isLoading;
        if (isLoading) {
            this.submitButton.classList.add('opacity-50');
        } else {
            this.submitButton.classList.remove('opacity-50');
        }
    }
}

// Initialize forms with callbacks
document.addEventListener('DOMContentLoaded', () => {
    // Initialize all forms with the callbacks
    const forms = document.querySelectorAll('[id^="js-form-"]');
    forms.forEach(form => {
        new SendMessageFormHandler(form.id);
    });

    analyticsManager.setupClickTracking();
});